module.exports = __webpack_public_path__ + "img/mode2-4.940bbcc1.png";